import SelectedPinIcon from './component'

export default SelectedPinIcon
